/* exported timeOffset, updateParticipant. sGetParticipantData */
/* global td, initTooltips, subscribeOnce, getSecDiffUtc, durationCounter */
var timeOffset = 0;

function updateParticipant(value) {
  log('updateParticipant');
  log(value);

  var homeTable = false;
  var lite = false;

  if ($('#participants-table')
    .hasClass('home-participants-table')) {
    homeTable = true;
    log('is it home-participants-table? ' + homeTable);
  }

  if ($('#participants-table').hasClass('lite')) {
    lite = true;
  }

  var participantRows = $('#participants-table tr').slice(0);
  var conferenceMatch = value.conference_match;
  var participantMatch = value.participant_match;
  var name = value.name;
  var id = conferenceMatch + '_' + participantMatch + '_' + name;
  var rId = value.conference_match + '_' + value.participant_match + '_' + value.name;
  var leader = '<span class="ns-glyphicon-not-registered"></span>';

  if (value.leader == 'leader') {
    leader = '<span class="ns-glyphicon-checkmark"></span>';
  }

  if (value.leader == 'bridge-spoke'
    || value.leader == 'bridge-hub'
    || value.aor_user == 'bridge'
  ) {
    return;
  }

  if (value.remove) {
    // DELETE
    participantRows.each(function (index) {
      if (participantRows[index].id == rId) {
        $(this).remove();
      }
    });
  } else {
    var found = false;

    var trTag = '';
    var html = '';

    trTag += '<tr'
      + ' data-gmt-start="' + value.time_begin + '"'
      + ' data-conference-id="' + conferenceMatch.replace('sip:', '') + '"'
      + ' data-participant-id="' + participantMatch.replace('sip:', '') + '"'
      + ' data-conference-match="' + conferenceMatch + '"'
      + ' data-participant-match="' + participantMatch + '"'
      + ' name="' + name + '"'
      + ' id="' + id + '">';

    var liteName = value.name;
    var ext = value.aor_user.replace('vb', '');

    if (ext.includes('guest_') || ext.length >= 10) {
      ext = '';
    }

    if (ext) {
      liteName += ' (' + ext + ')';
    }

    var connectedBy = value.aor_user.includes('vb') ? _('Web') : _('Phone');

    if (lite) {
      html += td(liteName);
    } else {
      html += td(value.name);
      html += td(value.aor_user);
    }

    if (!homeTable) {
      var counterclass = '';

      if (!lite) {
        html += td(leader);
        counterclass = 'hidden';

        if (value.mode == 'record_name') {
          html += '<td class="participant-mode"><span class="label capitalize">Recording Name</span></td>';
        } else if (value.mode == 'moh') {
          html += '<td class="participant-mode"><span class="label capitalize">Waiting</span></td>';
        } else if (value.mode == 'muted') {
          html += `<td class="participant-mode"><span class="label label-danger capitalize">${value.mode}</span></td>`;
          counterclass = 'nohide';
        } else if (value.mode == 'active') {
          html += `<td class="participant-mode"><span class="label label-success capitalize">${value.mode}</span></td>`;
          counterclass = 'nohide';
        } else if (value.mode == 'announcing') {
          html += '<td class="participant-mode"><span class="label capitalize">Joining</span></td>';
        } else {
          html += `<td class="participant-mode"><span class="label capitalize">${value.mode}</span></td>`;
        }
      } else {
        html += td(connectedBy);
      }

      html += td(`<span data-gmt-start="${value.time_begin}" data-gmt-answer="${value.time_begin}" class="duration_counter ${counterclass}"></span>`);

      if (!lite) {
        html += '<td class="action-buttons"><div class="action-buttons-inner"><div class="btn-group">';

        if (value.mode == 'muted') {
          html += `<a class="btn btn-default btn-xs helpsy mute-user"
   data-tooltip-container=".table-container"
   title="${_('Unmute')}"
   onclick="unmuteParticipant($(this));"><i class="fa fa-microphone-slash text-danger"></i></a>`;
        } else {
          html += `<a class="btn btn-default btn-xs helpsy mute-user"
   data-tooltip-container=".table-container"
   title="${_('Mute')}"
   onclick="muteParticipant($(this));"><i class="fa fa-microphone text-success"></i></a>`;
        }

        html += `<a class="btn btn-default btn-xs helpsy mute-user"
   data-tooltip-container=".table-container"
   title="${_('Disconnect')}"
   onclick="discParticipant($(this));"><i class="fa fa-trash-o"></i></a>`;

        html += '</div></div></td>';
      }
    }

    trTag += html;
    trTag += '</tr>';

    participantRows.each(function (index) {
      if (participantRows[index].id == rId) {
        // MODIFY
        log('MODIFY');

        if (value.mode != 'inactive') {
          $(this).show();
        }

        if (value.mode != 'active' && value.mode != 'muted') {
          $(this)
            .find('.duration_counter')
            .hide();
        } else {
          $(this)
            .find('.duration_counter')
            .show();
        }

        $(this).html(html);
        found = true;
      }
    });

    if (!found) {
      // ADD
      log('ADD');
      $('#participants-table > tbody').last().append(trTag);
    }

    // init tooltips on new html
    initTooltips();
  }

  var rowCount = participantRows.length;

  if (rowCount > 0) {
    $('.nonecreated').hide();
  } else {
    $('.nonecreated').show();
  }
}

var participantSocketHandlersBound = false;

function sGetParticipantData(type, domain, filter) {
  if (typeof socket == 'undefined') {
    return;
  }

  var options = {
    domain: domain,
    bridge: filter,
    type: 'participant',
  };

  if (typeof filter != 'undefined' && filter != '' && filter != '*') {
    options.filter = filter;
  }

  netsapiens.api.getAccessToken()
    .then(function (accessToken) {
      options.bearer = accessToken;
      subscribeOnce(options);
    });

  // Register only once - reached again on every socket reconnect.
  if (participantSocketHandlersBound) {
    return;
  }

  participantSocketHandlersBound = true;

  socket.on('participant', function (data) {
    updateParticipant(data);
  });
}

$(function () {
  if (typeof servertime != 'undefined') {
    timeOffset = getSecDiffUtc(servertime);
  }

  setInterval(durationCounter, 1000);
});
